<button [className]="options.type ? ' mt-2 btn btn-'+options.type: 'mt-2 btn btn-primary'" type="button" [disabled]="options.loading">
  <ng-content></ng-content>
  <i *ngIf="options.loading" class="fa fa-spinner fa-spin ml-2"></i>
</button>
